import gql from 'graphql-tag';

export default gql`
  fragment sensesContactCreateActivityFragment on SensesContactCreateActivity {
    sensesContactId
    preleadContactFirstName
    preleadContactLastName
  }
`;
